import TMain from './t-main';

export default TMain;
